import Swiper from 'swiper/bundle'

export const initInstagram = () => {
  const section = document.querySelector('.instagram-slider')
  const el = section && section.querySelector('.js-instagram-swiper')
  // Lives above the footer, outside the async page area, so only build it once
  if (!el || el.swiper) return

  new Swiper(el, {
    slidesPerView: 2.2,
    spaceBetween: 12,
    grabCursor: true,
    navigation: {
      prevEl: section.querySelector('.js-instagram-prev'),
      nextEl: section.querySelector('.js-instagram-next'),
    },
    breakpoints: {
      600: { slidesPerView: 3, spaceBetween: 20 },
      1000: { slidesPerView: 4, spaceBetween: 24 },
    },
  })
}
